/**
 * A failed step of RudderStack's validation of a warehouse account (ACT2-1077). The server describes
 * the step as a `WarehouseProblem`; a step from a server that predates that keeps its name and text.
 */
import * as React from 'react';

import { Callout } from '@/_shared/components/ui/callout';
import { WarehouseProblemCallout } from '@/_shared/components/WarehouseProblemCallout/WarehouseProblemCallout';

import type { FailedStep } from '../addAccount/PlatformAccountStep';

export function FailedStepCallout({ step }: { step: FailedStep }): React.JSX.Element {
  if (step.problem) return <WarehouseProblemCallout problem={step.problem} />;
  return (
    <Callout variant="error">
      <p>{step.name}</p>
      <p>{step.error}</p>
    </Callout>
  );
}
